export type ReleaseCardSavedState = "collection" | "wishlist" | null;

export function releaseCardSavedState(
  inCollection: boolean,
  inWishlist: boolean,
): ReleaseCardSavedState {
  if (inCollection) return "collection";
  if (inWishlist) return "wishlist";
  return null;
}
